import { SHAKE_LOOP_KEY, BOUNCE_LOOP_KEY } from 'js/config/consts';
import { ExistingScribeModel, VSImageShapeOrTextElementModel } from 'js/types';

import { defaultShakeTiming, defaultBounceEmphasisTiming } from '../resources/scribedefaults';

type GetEmphasisAnimationDurationParams = {
  elements: Array<VSImageShapeOrTextElementModel>;
  scribe: ExistingScribeModel;
};

const getEmphasisAnimationDuration = ({ elements, scribe }: GetEmphasisAnimationDurationParams) => {
  const { settings } = scribe;
  const defaultTiming = settings.emphasisAnimationTime;

  const durationSet = new Set<number>();
  for (const el of elements) {
    if (el?.emphasisTween?.id === SHAKE_LOOP_KEY) {
      durationSet.add(
        el.emphasisAnimationTime && el.emphasisAnimationTime !== 0 ? el.emphasisAnimationTime : defaultShakeTiming
      );
    } else if (el?.emphasisTween?.id === BOUNCE_LOOP_KEY) {
      durationSet.add(
        el.emphasisAnimationTime && el.emphasisAnimationTime !== 0
          ? el.emphasisAnimationTime
          : defaultBounceEmphasisTiming
      );
    } else if (!el.emphasisTween) {
      durationSet.add(el.emphasisAnimationTime ?? 0);
    } else {
      durationSet.add(
        el.emphasisAnimationTime && el.emphasisAnimationTime !== 0 ? el.emphasisAnimationTime : defaultTiming
      );
    }

    // If we have more that one value in the set, short circuit as values are different
    if (durationSet.size > 1) {
      return '-';
    }
  }

  if (durationSet.size === 0) {
    return '-';
  }

  // At this point only one value will be in the set, return it
  return durationSet.values().next().value as number;
};

export default getEmphasisAnimationDuration;
